<template>
    <div class="pb-4">
        <div class="card-header text-center">
            <span class="card-header__title">{{ $t('AppVehicleInfoLastContact.Último contato') }}</span>
        </div>
        <div class="row pt-3">
            <div class="col-sm-7 col-12">
                <div class="d-flex flex-column align-items-center field-value">
                    <div>
                        <div v-if="vehicle.last_contact">
                            {{ dateHourFormat(vehicle.last_contact) }}
                        </div>
                        <div v-else>
                            N/D
                        </div>
                    </div>
                    <div>
                        <div v-if="vehicle.city && vehicle.state_code">
                            {{ vehicle.city + ' - ' + vehicle.state_code }}
                        </div>
                        <div v-else>
                            N/D
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-5 col-12">
                <div class="d-flex flex-column align-items-center mt-sm-0 mt-3">
                    <div class="field-title">
                        {{ $t('AppVehicleInfoLastContact.Horímetro') }}
                    </div>
                    <div class="field-value">
                        <div v-if="vehicle.hour_meter">
                            {{ vehicle.hour_meter }} h
                        </div>
                        <div v-else>
                            N/D
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import dateHourFormat from "@/mixins/DateMixin";

export default {
    mixins: [dateHourFormat],
    props: {
        vehicle: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

.card-header {
    padding: 16px 18px;
    border-bottom: 1px solid #f0f2f3;
}

.card-header__title {
    font-size: 1.05rem;
    font-weight: 600;
    color: #3a3a3a;
}

.field-title {
    color: #8a949c;
    font-size: .82rem;
    text-transform: uppercase;
    letter-spacing: .03em;
}

.field-value {
    color: #2b2b2b;
    font-weight: 600;
    font-size: 1.02rem;
}

</style>
